import { getLocalStorage } from '@/utils/localstorage';

export type WebinarUtmAttribution = {
	'utm_sfdc-campaign-id': string;
	utm_source: string;
	utm_bmcr_source: string;
	utm_medium: string;
	utm_campaign: string;
	utm_content: string;
};

const EMPTY_ATTRIBUTION: WebinarUtmAttribution = {
	'utm_sfdc-campaign-id': '',
	utm_source: '',
	utm_bmcr_source: '',
	utm_medium: '',
	utm_campaign: '',
	utm_content: '',
};

const URL_KEYS = [
	'utm_sfdc-campaign_id',
	'utm_source',
	'utm_bmcr_source',
	'utm_medium',
	'utm_campaign',
	'utm_content',
] as const;

type MarketingContext = {
	utm?: {
		sfdcCampaignId?: unknown;
		source?: unknown;
		medium?: unknown;
		campaign?: unknown;
		content?: unknown;
	};
};

const asString = (value: unknown): string => (typeof value === 'string' ? value : '');

const getUrlAttribution = (params: URLSearchParams): WebinarUtmAttribution => ({
	'utm_sfdc-campaign-id': params.get('utm_sfdc-campaign_id') ?? '',
	utm_source: params.get('utm_source') ?? '',
	utm_bmcr_source: params.get('utm_bmcr_source') ?? '',
	utm_medium: params.get('utm_medium') ?? '',
	utm_campaign: params.get('utm_campaign') ?? '',
	utm_content: params.get('utm_content') ?? '',
});

const getStoredAttribution = (rawMarketingContext?: string | null): WebinarUtmAttribution => {
	if (!rawMarketingContext) {
		return EMPTY_ATTRIBUTION;
	}

	try {
		const marketingContext = JSON.parse(rawMarketingContext) as MarketingContext;
		return {
			'utm_sfdc-campaign-id': asString(marketingContext.utm?.sfdcCampaignId),
			utm_source: asString(marketingContext.utm?.source),
			utm_bmcr_source: '',
			utm_medium: asString(marketingContext.utm?.medium),
			utm_campaign: asString(marketingContext.utm?.campaign),
			utm_content: asString(marketingContext.utm?.content),
		};
	} catch {
		return EMPTY_ATTRIBUTION;
	}
};

export const getWebinarUtmAttribution = (
	search = typeof window === 'undefined' ? '' : window.location.search,
	rawMarketingContext = getLocalStorage('marketingContext', true),
): WebinarUtmAttribution => {
	const params = new URLSearchParams(search);
	const hasUrlAttribution = URL_KEYS.some((key) => params.has(key));

	if (hasUrlAttribution) {
		return getUrlAttribution(params);
	}

	return getStoredAttribution(rawMarketingContext);
};
